import { Button, BackTop, Modal } from 'antd';
import classnames from 'classnames';
import classes from './index.module.scss';
import styles from './index.module.scss';
import type { ButtonProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import quickOrderImg from '@/assets/image/quickorder.png';
import Plus from '@/assets/image/Plus.png';
import Order from '@/assets/image/Order.png';
import shutDown from '@/assets/image/shutDown.png';
import customerServcie from '@/assets/image/customerService.png';
import littleCart from '@/assets/image/littleCart.png';
import collect from '@/assets/image/collect.png';
import Service from '@/assets/image/Service.jpg';
import {
  HomeOutlined,
} from '@ant-design/icons';

const ButtonGroup = () => {
    const [seeting, setIsSetting] = useState(false);
    const [service, setService] = useState(false);
    const navigate = useNavigate();
const [cegImgList] = useState([
    {
      img: littleCart,
      text: '购物车',
      style: {
        top: '-20px',
        left: '50%',
        transform: `translateX(-50%)`,
      },
    },
    {
      img: Order,
      text: '订单',
      style: {
        right: '-30px',
        top: '50%',
        transform: `translateY(-50%)`,
      },
    },
    {
      img: customerServcie,
      text: '客服',
      style: {
        bottom: '-40px',
        left: '50%',
        transform: `translateX(-50%)`,
      },
    },
    {
      img: collect,
      text: '收藏',
      style: {
        top: '50%',
        left: '-30px',
        transform: `translateY(-50%)`,
      },
    },
  ]);



    const handleItemClick = text => {
        switch (text) {
          case '购物车':
            // 处理点击购物车的逻辑
            navigate('/cart');
            //console.log('点击了购物车');
            break;
          case '收藏':
            // 处理点击收藏的逻辑
            navigate('/personal-center/my-favorite');
            //console.log('点击了收藏');
            break;
          case '客服':
            // 处理点击客服的逻辑
            setService(true);
            //console.log('点击了客服');
            break;
          case '订单':
            navigate('/personal-center/order-list');
            //console.log('点击了订单');
            break;
          default:
            break;
        }
      };
    return (
        <>
        {service && (
        <Modal
          onCancel={() => {
            setService(false);
          }}
          onOk={() => {
            setService(false);
          }}
          visible={true}>
          <div>
            <div>客服电话：</div>联系客服请添加客服二维码或拨打客服电话：
            <div>021-35961881 021-35961885</div>
            <img width={200} height={260} src={Service}></img>
          </div>
        </Modal>
      )}
        <div className={styles.settting}>
            <div
                className={styles.noContent}
                onClick={() => {
                    //console.log(seeting);
                    setIsSetting(!seeting);
            }}>
                {seeting ? <img src={shutDown} width={15}></img> : <img src={Plus} width={15}></img>}
            </div>
            {seeting && (
            <div className={styles.ceg} style={{ display: `${seeting ? 'block' : 'none'}` }}>
            {cegImgList.map((item, index) => {
                return (
                    <div
                    className={styles.ced_item}
                    style={item.style}
                    key={`ceg_${index}`}
                    onClick={() => handleItemClick(item.text)}>
                    <img src={item.img} alt="" />
                    {item.text}
                    </div>
                );
            })}
             </div>
            )}
        </div>
        {seeting ? <BackTop className={styles.backTop} /> : <BackTop className={styles.backTopUp} />}
        {seeting ? <div className={styles.backHome} onClick={() => {
          navigate("/");
        }}><HomeOutlined style={{marginLeft: "7px", marginTop: "5px"}}/></div> : 
        <div className={styles.backHomeDown} onClick={() => {
          navigate("/");
        }}><HomeOutlined style={{marginLeft: "7px", marginTop: "5px"}}/></div>}
        </>
    )
}

export default ButtonGroup